var React = require('react');

function Angular (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M127.606.341L.849 44.95 20.88 211.022l106.86 58.732 107.412-59.528L255.175 44.16 127.606.341z","fill":"#B3B3B3","key":0}),React.createElement("path",{"d":"M242.532 53.758L127.31 14.466v241.256l96.561-53.441 18.66-148.523z","fill":"#A6120D","key":1}),React.createElement("path",{"d":"M15.073 54.466l17.165 148.525 95.07 52.731V14.462L15.074 54.465z","fill":"#DD1B16","key":2}),React.createElement("path",{"d":"M159.027 142.898L127.31 157.73H93.881l-15.714 39.305-29.228.54L127.31 23.227l31.717 119.672zm-3.066-7.467l-28.44-56.303-23.329 55.334h23.117l28.652.97z","fill":"#F2F2F2","key":3}),React.createElement("path",{"d":"M127.309 23.226l.21 55.902 26.47 55.377h-26.62l-.06 23.189 36.81.035 17.204 39.852 27.967.518-81.981-174.873z","fill":"#B3B3B3","key":4})]);
}

Angular.defaultProps = {"width":"51px","height":"51px","viewBox":"0 0 256 270"};

module.exports = Angular;

Angular.default = Angular;
